export default "__VITE_ASSET__CSukApQb__"